<template>
  <el-container>
    <el-main style="padding: 0">
      <span>上料验证扫描</span>
      <el-divider />
      <el-form ref="form" style="width: 500px" :model="model" class="form" label-width="80px" @submit.native.prevent>
        <el-form-item label="派工单号">
          <el-input
            ref="orderNoInput"
            v-model.trim="model.orderNo"
            placeholder="请扫描派工单号"
            @keyup.enter.native="$refs.strNoInput.focus()"
          />
        </el-form-item>
        <el-form-item label="序列号">
          <el-input
            ref="strNoInput"
            v-model.trim="model.strNo"
            :disabled="!model.orderNo"
            placeholder="请扫描序列号"
            @keyup.enter.native="scanHandle"
          />
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      model: {
        orderNo: "",
        strNo: "",
      },
    };
  },

  mounted() {
    this.$refs.orderNoInput.focus();
  },

  methods: {
    scanHandle() {
      this.$http.post("basic", "productionScan/scanPrepare", this.model).then((res) => {
        if (res.success) {
          this.$message.success("验证成功");
          this.$refs.orderNoInput.focus();
        }
        this.model = {};
      });
    },
  },
};
</script>
